import {
    useCreateAufgabeInboundPrompt,
    useDeleteAufgabeInboundPrompt,
    useSetActiveAufgabeInboundPrompt,
    useUpdatePrompt,
} from "../../client/hooks";
import {usePromptHandlingBase} from "./useAufgabenPromptHandling";

export function useAufgabenInboundPromptHandling(aufgabeId: string) {
    const createPrompt = useCreateAufgabeInboundPrompt();
    const updatePrompt = useUpdatePrompt();
    const setActivePromptRaw = useSetActiveAufgabeInboundPrompt();
    const deletePrompt = useDeleteAufgabeInboundPrompt();

    const setActivePrompt = (id: string, promptId: string) => setActivePromptRaw(id, {promptId});
    return usePromptHandlingBase(
        aufgabeId,
        [
            ["api", "v1", "aufgaben", aufgabeId, "inbound-prompts"],
            ["api", "v1", "aufgaben", aufgabeId],
            ["api", "v1", "prompts"],
        ],
        createPrompt, updatePrompt, setActivePrompt, deletePrompt,
    );
}
